import React, { useEffect, useState } from 'react'
import { Col, Row, Form, Button, Tooltip } from 'antd'
import 'react-quill/dist/quill.snow.css'

import { SaveOutlined } from '@ant-design/icons'
import {
    type ModelProps,
    type PinedMessage,
} from '../../../Types/ToDoViewAllList'
import { useDispatch } from 'react-redux'
import { SavePinnedChat } from '../../../Services/ToDoViewAllList'
import CustomQuill from '../../../Components/CustomQuill'
interface ProcessRemarkProps extends ModelProps {
    auditdata?: PinedMessage
}
const ProcessRemarks = (props: ProcessRemarkProps): React.ReactElement => {
    const {
        auditdata,
        serviceProcessId,
        serviceId,
        referenceId,
        businessType,
        changeModalStatus,
    } = props
    const [form] = Form.useForm()
    const [emailText, setEmailText] = useState(auditdata?.description)
    const dispatch = useDispatch()
    const [buttonLoading, setButtonloading] = useState(false)
    const onSave = (): void => {
        void onSavePhone()
    }

    useEffect(() => {
        setEmailText(auditdata?.description)
    }, [auditdata])
    const onSavePhone = async (): Promise<void> => {
        try {
            setButtonloading(true)
            await form.validateFields()

            const dataToSave = {
                msgReferenceId: serviceProcessId,
                businessTypeId: businessType ?? 0,
                referenceId: referenceId ?? 0,
                chatId: 0,
                serviceId: serviceId ?? 0,
                description: emailText ?? '',
            }

            await SavePinnedChat(dispatch, dataToSave)
                .then((result) => {
                    if (result !== null && result !== undefined) {
                        setButtonloading(false)
                    }
                })
                .catch(() => {})

            form.setFieldsValue({
                description: '',
            })

            changeModalStatus()
        } catch (error) {}
    }
    return (
        <Form
            name="complex-form"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            layout={'vertical'}
            autoComplete="off"
            form={form}
        >
            <div style={{ height: '250px' }}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item label="Describe workflow process details here. It may useful tips for working user.">
                            <CustomQuill
                                onDescriptionChange={(content) => {
                                    setEmailText(content)
                                }}
                                emailText={emailText ?? ''}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>

            <Row>
                <Col offset={21} span={2}>
                    <Form.Item>
                        <Tooltip title="Save Details">
                            <Button
                                type="primary"
                                size="middle"
                                onClick={onSave}
                                loading={buttonLoading}
                            >
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}

export default ProcessRemarks
